import React, { useState } from "react";
import { Plus, Minus } from "lucide-react"; // optional icons package

const faqData = [
  {
    question:
      "What makes Inggage different from traditional influencer marketing platforms?",
    answer:
      "Inggage is India’s first AI-powered, performance-based influencer marketing platform. Unlike traditional platforms that charge upfront fees without guaranteed performance, Inggage uses the ACPV model (Accountable Cost Per View), where brands pay only for actual engagement. It also offers real-time analytics, consumer insights, and campaign tracking for better ROI.",
  },
  {
    question: "What is the ACPV model and how does it benefit brands?",
    answer:
      "The ACPV (Accountable Cost Per View) model ensures that brands only pay for real, measurable engagement. This eliminates overcharging, ensures campaign accountability, and maximizes ROI by filtering out non-performing creators and focusing on genuine performance metrics.",
  },
  {
    question: "How does Inggage use AI in influencer marketing?",
    answer:
      "Inggage uses artificial intelligence to optimize content strategy, campaign timing, and creator selection. It helps brands understand what type of content performs best, when to post it, and which creators are most aligned with their audience. AI also tracks market trends and predicts demand, making influencer marketing smarter and more effective.",
  },

  {
    question: "What kind of insights does Inggage provide about consumers?",
    answer:
      "Inggage offers data-backed consumer profiling, including demographics such as age, gender, and location, along with interests, behavior patterns, and content preferences. These insights help brands make informed decisions, target the right audience, and run campaigns that resonate with consumers for better performance.",
  },

  {
    question: "What results have brands seen with Inggage so far?",
    answer:
      "Inggage has already gained strong traction in the market. Over 25 brands have engaged with the platform, and more than 2000 influencers have joined, with 500+ ready to work on ACPV-based campaigns. Brands such as Purplle, AccioJob, and Lyzr have reported excellent results, praising the platform’s efficiency, cost-effectiveness, and transparency.",
  },
];

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="  md:mx-24 xs:mx-4  px-4 py-10"
      style={{ fontFamily: "Gilroy-Medium" }}
    >
      <h2 className="text-3xl font-bold text-center mb-3">FAQS</h2>
      <div className="divide-y divide-gray-300">
        {faqData.map((faq, index) => (
          <div key={index} className="py-4 border-b border-gray-300">
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <p className="text-gray-800 text-lg mb-0">{faq.question}</p>
              <span className="text-gray-600">
                {openIndex === index ? <Minus size={20} /> : <Plus size={20} />}
              </span>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${
                openIndex === index ? "max-h-40 mt-3" : "max-h-0"
              }`}
            >
              <p className="text-gray-600 text-sm mb-0">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;
